(function () {
  'use strict';
  function tags(p) { return (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).join(',').toLowerCase(); }
  function cents(value) { return /^\d+(?:\.\d{1,2})?$/.test(String(value)) ? Math.round(Number(value) * 100) : null; }
  function groupFor(p) {
    var type = String(p.product_type || '').trim().toLowerCase();
    var evidence = tags(p) + ' ' + String(p.title || '').toLowerCase() + ' ' + type;
    if (/gift[ -]only|complimentary[ -]gift|membership|gift[ -]card|service|divination/.test(type + ' ' + tags(p))) return '';
    if (/collector|collectible|收藏级/.test(evidence)) return 'collectors';
    if (/phone|bowl|cup|rug|textile|statue|ornament|chime/.test(type)) return 'objects';
    if (/(?:^|\s)(?:necklaces?|pendants?|bracelets?|rings?|earrings?)$/.test(type) || type === 'mala beads' || type === 'prayer beads' || type === 'dzi bead jewelry' || type === 'dzi bead') return 'jewelry';
    if (/^(?:thangka art|meditation stones|gemstone dice)$/.test(type)) return 'objects';
    return '';
  }
  function pricing(p) {
    var prices = (p.variants || []).filter(function (v) { return v.available && v.requires_shipping; }).map(function (v) { return cents(v.price); }).filter(function (v) { return v !== null && v > 0; });
    if (!prices.length) return null;
    var current = Math.min.apply(Math, prices);
    var minimum = Math.min.apply(Math, (p.variants || []).map(function (v) { return cents(v.price); }).filter(function (v) { return v !== null; }));
    var excluded = minimum > 100000 || current > 100000 || groupFor(p) === 'collectors' || /collector|gift[ -]only|membership|no.discount/.test(tags(p)) || /collector|收藏级/i.test(String(p.title || '') + ' ' + String(p.product_type || ''));
    return { current: current, member: excluded ? null : Math.round(current * 7 / 10), from: new Set(prices).size > 1 };
  }
  function category(p) {
    var type = String(p.product_type || p.title).toLowerCase();
    var rules = [['thangka', /thangka/], ['ring', /ring/], ['bracelet', /bracelet/], ['textile', /rug|mat|textile/], ['vessel', /bowl|cup|vessel/], ['mala', /mala|108/], ['sculpture', /statue|sculpture/], ['charm', /phone|dice/], ['necklace', /necklace|pendant|amulet|tsa.tsa/], ['dzi', /dzi/], ['stone', /crystal|stone/]];
    var found = rules.find(function (rule) { return rule[1].test(type); });
    return found ? found[0] : type || 'other';
  }
  function pick(products, random, limit) {
    var seen = new Set(), rng = random || Math.random;
    var pool = products.filter(function (p) {
      if (!p || !groupFor(p) || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(p.handle || '') || seen.has(p.handle) || !p.title || !pricing(p)) return false;
      if (/gift[ -]only|membership/.test(tags(p)) || /complimentary-gift|gift-card|membership/.test(p.handle)) return false;
      try { if (new URL(p.images[0].src).protocol !== 'https:') return false; } catch (e) { return false; }
      seen.add(p.handle); return true;
    });
    for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(rng() * (i + 1)), t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
    var selected = [], used = new Map(), group = new Set();
    while (selected.length < limit && pool.length) {
      if (selected.length % 5 === 0) group.clear();
      var best = 0, score = Infinity;
      pool.forEach(function (p, i) { var key = category(p), value = (group.has(key) ? 100 : 0) + (used.get(key) || 0); if (value < score) { best = i; score = value; } });
      var p = pool.splice(best, 1)[0], key = category(p);
      selected.push(p); group.add(key); used.set(key, (used.get(key) || 0) + 1);
    }
    return selected;
  }
  function chooseGroups(products, random) {
    var jewelry = pick(products.filter(function (p) {
      if (!p || groupFor(p) !== 'jewelry') return false;
      var evidence = tags(p) + ' ' + String(p.title || '').toLowerCase() + ' ' + String(p.product_type || '').toLowerCase();
      if (/phone|bowl|cup|rug|carpet|textile|statue|ornament|chime|地毯|藏毯|杯|碗/.test(evidence)) return false;
      return Array.isArray(p.variants) && p.variants.length > 0 && p.variants.every(function (v) { var price = cents(v.price); return price !== null && price <= 100000; });
    }), random, 10);
    return [jewelry.slice(0, 5), jewelry.slice(5, 10), pick(products.filter(function (p) { return p && groupFor(p) === 'collectors'; }), random, 5), pick(products.filter(function (p) { return p && groupFor(p) === 'objects'; }), random, 5)];
  }
  function choose(products, random) { return [].concat.apply([], chooseGroups(products, random)); }
  if (typeof module !== 'undefined' && module.exports) module.exports = { choose: choose, chooseGroups: chooseGroups, groupFor: groupFor, category: category, pricing: pricing };
  if (typeof document === 'undefined') return;
  var poolPromise;
  function catalog(endpoint) {
    if (!poolPromise) poolPromise = (async function () {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        var products = [], seen = new Set();
        for (var page = 1; page <= 100; page++) {
          var url = new URL(endpoint, location.origin);
          if (url.origin !== location.origin || !url.pathname.endsWith('/collections/all/products.json')) throw Error('Invalid catalog');
          url.searchParams.set('page', page); url.searchParams.set('limit', 250);
          var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw Error('Catalog unavailable');
          var data = await response.json(); if (!Array.isArray(data.products)) throw Error('Invalid products');
          var key = data.products.map(function (p) { return p.handle; }).join('|');
          if (seen.has(key)) throw Error('Repeated page'); seen.add(key);
          products.push.apply(products, data.products);
          if (data.products.length < 250) return products;
        }
        throw Error('Catalog limit');
      } finally { clearTimeout(timer); }
    }());
    return poolPromise;
  }
  function element(tag, className, text) { var node = document.createElement(tag); node.className = className; if (text != null) node.textContent = text; return node; }
  function card(p, root, index) {
    var tile = element('article', 'pk-mosaic__card' + (index % 5 === 0 ? ' pk-mosaic__card--large' : ''));
    tile.dataset.category = category(p); tile.dataset.handle = p.handle;
    var href = root.dataset.productBase + p.handle;
    var media = element('a', 'pk-mosaic__media'); media.href = href; media.setAttribute('aria-label', p.title);
    var img = element('img', ''); var source = new URL(p.images[0].src); source.searchParams.set('width', index % 5 === 0 ? 1200 : 600);
    img.src = source.href; img.alt = p.title; img.width = 600; img.height = 600; img.loading = 'lazy'; img.decoding = 'async'; media.append(img);
    var copy = element('div', 'pk-mosaic__copy'), title = element('a', 'pk-mosaic__name', p.title); title.href = href;
    var price = pricing(p), line = element('div', 'pk-mosaic__prices');
    var money = function (n) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency, currencyDisplay: 'code' }).format(n / 100); };
    var prefix = price.from ? root.dataset.from + ' ' : '';
    if (globalThis.PKOpeningSale) globalThis.PKOpeningSale.renderPrice(line, p, price.current, money, prefix);
    else line.textContent = prefix + money(price.current);
    copy.append(title, line);
    tile.append(media, copy); return tile;
  }
  async function init(root) {
    if (root.dataset.mosaicState) return; root.dataset.mosaicState = 'loading';
    try {
      var groups = chooseGroups(await catalog(root.dataset.catalog));
      if (!groups.some(function (group) { return group.length; }) || !root.isConnected || root.contains(document.activeElement)) { root.dataset.mosaicState = 'fallback'; return; }
      var content = document.createDocumentFragment();
      groups.forEach(function (products, group) { if (!products.length) return; var row = element('div', 'pk-mosaic__group'); row.dataset.productGroup = ['jewelry', 'jewelry', 'collectors', 'objects'][group]; products.forEach(function (p, i) { row.append(card(p, root, i)); }); content.append(row); });
      root.querySelector('.pk-mosaic__groups').replaceChildren(content); root.dataset.mosaicState = 'ready';
    } catch (e) { root.dataset.mosaicState = 'fallback'; }
  }
  var observed = new WeakSet();
  function prepare(root) {
    if (observed.has(root)) return;
    observed.add(root);
    if (typeof IntersectionObserver === 'undefined') { init(root); return; }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      init(root);
    }, { rootMargin: '800px 0px' });
    observer.observe(root);
  }
  function all(target) { target.querySelectorAll('[data-pk-product-mosaic]').forEach(prepare); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(document); }, { once: true }); else all(document);
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
}());
